import React, { useEffect, useRef, useState } from "react";
import { Card, CardBody, Col, Row, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import isEqual from 'lodash/isEqual';
import am4lang_es_ES from "@amcharts/amcharts4/lang/es_ES"
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

const am4themes_customTheme = (target) => {
  if(target instanceof am4core.ColorSet){
    target.list = [
      am4core.color("#1D1F3F"),
      am4core.color("#097AAF"),
      am4core.color("rgba(0, 117, 172, 0.5)")
    ]
  }
};

am4core.useTheme(am4themes_customTheme);

const AreaChart = ({ title, data, id, popoverTitle, popoverBody, valueName , sleep}) => {
  const chartRef = useRef();
  const [showPopover, setShowPopover] = useState(false);

  const handleShowPopover = () => {
    setShowPopover(true)
  }

  const handleHidePopover = () => {
    setShowPopover(false)
  }

  useEffect(() => {
    let chart = am4core.create(chartRef.current, am4charts.XYChart);
    chart.language.locale = am4lang_es_ES;
    chart.paddingRight = 20;
    chart.responsive.enabled = true;

    if(data){
      chart.data = data;
    }
    else{
        chart.data = generateChartData();
    }

    //console.log("data es:", chart.data);
    if( data.length === 0 ){
      let label = chart.createChild(am4core.Label);
      label.text = "No hay datos registrados";
      label.fontSize = 20;
      label.align = "center";
      label.isMeasured = false;
      label.x = am4core.percent(50);
      label.horizontalCenter = "middle";
      label.y = am4core.percent(50);
    }

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    dateAxis.tooltipDateFormat = "HH:mm:ss, d MMMM";

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.title.text = title;

    let series = chart.series.push(new am4charts.LineSeries());
    let myBullet = new am4charts.CircleBullet();
    myBullet.circle.strokeWidth = 0;
    
    if( sleep ){
      dateAxis.baseInterval = {
        "timeUnit": "minute",
        "count": 5
      };
      myBullet.adapter.add("fill", function(fill, target){
        if(!target.dataItem){
          return fill;
        }
        let values = target.dataItem.values;
        return values.valueY.value <= 8
        ? am4core.color("#6771dc")
        : values.valueY.value <= 40
          ? am4core.color("#67b7dc")
          : am4core.color("#ffc400");
      })
      series.tooltip.getFillFromObject = false;
      series.tooltip.background.fill = am4core.color("#000000");

      // Create a range to change stroke for values below 0
      var range = valueAxis.createSeriesRange(series);
      range.value = 0;
      range.endValue = 8;
      range.contents.stroke = am4core.color("#6771dc");
      range.contents.fill = range.contents.stroke;
      range.contents.strokeOpacity = 1;
      range.contents.fillOpacity = 0.3;

      var range2 = valueAxis.createSeriesRange(series);
      range2.value = 8;
      range2.endValue = 40;
      range2.contents.stroke = am4core.color("#67b7dc");
      range2.contents.fill = range2.contents.stroke;
      range2.contents.strokeOpacity = 1;
      range2.contents.fillOpacity = 0.3;

      var range3 = valueAxis.createSeriesRange(series);
      range3.value = 40;
      range3.endValue = 1000;
      range3.contents.stroke = am4core.color("#ffc400");
      range3.contents.fill = range3.contents.stroke;
      range3.contents.strokeOpacity = 1;
      range3.contents.fillOpacity = 0.3;
    }else{
      dateAxis.baseInterval = {
        "timeUnit": "minute",
        "count": 1
      };
      series.fillOpacity = 0.3;
      series.strokeWidth = 2;
    }
    myBullet.circle.radius = 3;
    series.bullets.push(myBullet);
    series.dataFields.dateX = "date";
    series.dataFields.valueY = valueName;
    series.tooltipText = valueName + ": [bold]{valueY}[/]";
    series.connect = false;



    chart.cursor = new am4charts.XYCursor();
    chart.cursor.lineY.opacity = 0;
    chart.scrollbarX = new am4charts.XYChartScrollbar();
    chart.scrollbarX.series.push(series);


    dateAxis.keepSelection = true;



    function generateChartData() {
        let chartData = [];
        // current date
        let firstDate = new Date();
        // now set 500 minutes back
        firstDate.setMinutes(firstDate.getDate() - 500);

        // and generate 500 data items
        let visits = 500;
        for (var i = 0; i < 100; i++) {
          let newDate = new Date(firstDate);
          // each time we add one minute
          newDate.setMinutes(newDate.getMinutes() + i);
          // some random number
          visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
          // add data item to the array
          let tmpData = {date: newDate};
          tmpData[valueName] = visits;
          chartData.push(tmpData);
      }
        for (let i = 300; i < 500; i++) {
            let newDate = new Date(firstDate);
            // each time we add one minute
            newDate.setMinutes(newDate.getMinutes() + i);
            // some random number
            visits += Math.round((Math.random()<0.5?1:-1)*Math.random()*10);
            // add data item to the array
            let tmpData = {date: newDate};
            tmpData[valueName] = visits;
            chartData.push(tmpData);
        }
        return chartData;
    }
    
    return () => { chart.dispose() };
  }, [data]);

  return (
    <Card className="chart-card">
      <CardBody>
        <Row>
          <Col lg={8} md={8}>
            <h5>{title}</h5>
            </Col>
          <Col lg={4} md={4}>
            <i className="fas fa-question-circle float-right pointer" id={id} onClick={handleShowPopover}></i>
            <Popover placement="bottom" isOpen={showPopover} target={id} toggle={handleHidePopover}>
              <PopoverHeader>{popoverTitle}</PopoverHeader>
              <PopoverBody>{popoverBody}</PopoverBody>
            </Popover>
          </Col>
        </Row>
        <div
          ref={chartRef}
          style={{ height: '90%', width: '100%' }}
        />
      </CardBody>
    </Card>
  )
}

export default React.memo(AreaChart, (prevProps, nextProps) => isEqual(prevProps, nextProps));